var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("omegaup-carousel"),
      _vm.coderOfTheMonthFemale ||
      _vm.coderOfTheMonth ||
      _vm.schoolOfTheMonth ||
      _vm.rankTable.resultTotal ||
      _vm.schoolsRank.totalRows
        ? _c("div", { staticClass: "container-lg py-5" }, [
            _c(
              "div",
              { staticClass: "row align-items-stretch justify-content-around" },
              [
                _vm.coderOfTheMonthFemale
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-10 col-sm-6 col-lg-4 mb-3 mb-lg-0"
                      },
                      [
                        _c("omegaup-coder-of-the-month", {
                          attrs: {
                            category: "female",
                            "coder-of-the-month": _vm.coderOfTheMonthFemale
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.coderOfTheMonth
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-10 col-sm-6 col-lg-4 mb-3 mb-lg-0"
                      },
                      [
                        _c("omegaup-coder-of-the-month", {
                          attrs: {
                            category: "all",
                            "coder-of-the-month": _vm.coderOfTheMonth
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.schoolOfTheMonth
                  ? _c(
                      "div",
                      {
                        staticClass: "col-xs-10 col-sm-6 col-lg-4 mb-3 mb-lg-0"
                      },
                      [
                        _c("omegaup-school-of-the-month", {
                          attrs: { "school-of-the-month": _vm.schoolOfTheMonth }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "row align-items-stretch justify-content-around mt-4"
              },
              [
                _vm.rankTable.resultTotal
                  ? _c(
                      "div",
                      { staticClass: "col-xs-10 col-md-6 mb-3 mb-md-0" },
                      [
                        _c("omegaup-user-rank", {
                          attrs: {
                            page: _vm.rankTable.page,
                            length: _vm.rankTable.length,
                            "is-index": _vm.rankTable.isIndex,
                            "is-logged": _vm.rankTable.isLogged,
                            "available-filters": _vm.rankTable.availableFilters,
                            filter: _vm.rankTable.filter,
                            ranking: _vm.rankTable.ranking,
                            "result-total": _vm.rankTable.resultTotal
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.schoolsRank.totalRows
                  ? _c(
                      "div",
                      { staticClass: "col-xs-10 col-md-6 mb-3 mb-md-0" },
                      [
                        _c("omegaup-school-rank", {
                          attrs: {
                            page: _vm.schoolsRank.page,
                            length: _vm.schoolsRank.length,
                            "show-header": _vm.schoolsRank.showHeader,
                            "total-rows": _vm.schoolsRank.totalRows,
                            rank: _vm.schoolsRank.rank
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _c("omegaup-testimonials"),
      _c(
        "div",
        { staticClass: "container-lg py-5" },
        [
          _c("omegaup-section", {
            attrs: {
              title: _vm.T.homepageCompeteSectionTitle,
              description: _vm.T.homepageCompeteSectionDescription,
              buttons: [
                {
                  text: _vm.T.buttonGoToContests,
                  href: "/arena/"
                }
              ],
              "image-src": "/media/homepage/contests_section.svg"
            }
          }),
          _c("omegaup-section", {
            attrs: {
              title: _vm.T.homepageTrainSectionTitle,
              description: _vm.T.homepageTrainSectionDescription,
              buttons: [
                {
                  text: _vm.T.buttonGoToProblems,
                  href: "/problem/"
                }
              ],
              "image-src": "/media/homepage/problems_section.svg",
              "image-to-right": true
            }
          }),
          _c("omegaup-section", {
            attrs: {
              title: _vm.T.homepageCreateSectionTitle,
              description: _vm.T.homepageCreateSectionDescription,
              buttons: !_vm.isUnder13User
                ? [
                    {
                      text: _vm.T.buttonCreateProblem,
                      href: "/problem/new/"
                    },
                    {
                      text: _vm.T.buttonCreateContest,
                      href: "/contest/new/"
                    }
                  ]
                : [],
              "image-src": "/media/homepage/create_section.svg"
            }
          }),
          _c("omegaup-section", {
            attrs: {
              title: _vm.T.homepageTeachSectionTitle,
              description: _vm.T.homepageTeachSectionDescription,
              buttons: [
                {
                  text: _vm.T.buttonGoToCourses,
                  href: "/course/"
                }
              ],
              "image-src": "/media/homepage/courses_section.svg",
              "image-to-right": true
            }
          }),
          _c("omegaup-sponsors", {
            attrs: {
              title: _vm.T.homepageSponsorsSectionTitle,
              logos: [
                {
                  class: "img-fluid mx-auto d-block my-4",
                  src: "/media/homepage/airbnb_logo.svg",
                  alt: "airbnbLogo",
                  href: "https://news.airbnb.com/2025-community-fund/"
                }
              ]
            }
          })
        ],
        1
      ),
      _c("omegaup-cookie-accept-decline", {
        on: {
          "cookie-clicked-accept": _vm.cookieClickedAccept,
          "cookie-clicked-decline": _vm.cookieClickedDecline,
          "cookie-clicked-postpone": _vm.cookieClickedPostpone
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }